export default function removeCurrencyFormat(val) {
  return val.replace(/[^\d.-]/g, '');
}
